import header from "./buerogrundriss-01.jpg";
import section10 from "./buerogrundriss-02.jpg";
import section1 from "./buerogrundriss-03.jpg";
import section8 from "./buerogrundriss-04.jpg";
import section11 from "./buerogrundriss-05.jpg";
import section6 from "./buerogrundriss-06.jpg";
import section7 from "./buerogrundriss-07.jpg";
import section2 from "./buerogrundriss.png";
import section5 from "./dreibund-mit-moebel.png";
import section3 from "./einbund-mit-moebel.png";
import section9 from "./unterschied-buerotypen.png";
import section4 from "./zweibund-mit-moebel.png";

export {
  header,
  section1,
  section10,
  section11,
  section2,
  section3,
  section4,
  section5,
  section6,
  section7,
  section8,
  section9,
};
